import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CurationServiceConfig } from './curation-service.types';

export function provideCurationService(config: CurationServiceConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'curationServiceConfig', useValue: config }
  ]);
}
